export default {"src":"/_next/static/media/lending-logo.70c84878.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};